import { render } from "./BaseTextArea.vue?vue&type=template&id=3c79b7ee&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"

import "./BaseTextArea.vue?vue&type=style&index=0&id=3c79b7ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c79b7ee"]])

export default __exports__